import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { cn } from "@/lib/chillnn/cn";

import DragIndicator from "@/components/ui/icon/drag-indicator";

import { QuestionPreQuestionItem } from "./pre-question-item";
import { QuestionCardItem } from "../../../system/question/card/card-item";

import type { QuestionPreQuestionRowProps } from "./pre-question-row";

type Props = QuestionPreQuestionRowProps;

/** `QuestionPreQuestions` で質問が2件以上のときのみマウントする。`useSortable` でラップした並べ替え可能行。 */
export const SortablePreQuestionRow = ({
	question,
	remove,
	onSetIsRequired,
	onSetTitle,
	onSetQuestionType,

	appendOptionItem,
	removeOptionItem,

	onSetOptionItem,
}: Props) => {
	const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
		id: question.questionID.value,
	});

	const sortableStyle = {
		transform: CSS.Transform.toString(transform),
		transition,
	};

	return (
		<QuestionCardItem
			removeItem={remove}
			ref={setNodeRef}
			style={sortableStyle}
			className={cn(isDragging && "!cursor-grabbing")}
		>
			<div
				ref={setActivatorNodeRef}
				className="absolute left-4 top-4"
				aria-label="質問の並べ替え"
				{...attributes}
				{...listeners}
			>
				<DragIndicator
					className={cn(
						"text-caption-50 hover:cursor-grab",
						isDragging ? "!cursor-grabbing" : "cursor-grab",
					)}
					size="default"
				/>
			</div>
			<QuestionPreQuestionItem
				question={question}
				mainSectionClassName="pl-10"
				onSetIsRequired={onSetIsRequired}
				onSetTitle={onSetTitle}
				onSetQuestionType={onSetQuestionType}
				appendOptionItem={appendOptionItem}
				removeOptionItem={removeOptionItem}
				onSetOptionItem={onSetOptionItem}
			/>
		</QuestionCardItem>
	);
};

SortablePreQuestionRow.displayName = "SortablePreQuestionRow";
